$(document).ready(function() {
    let t = document.querySelectorAll("[data-product-variant]");
    var a = document.querySelectorAll(".product-tile.quick-view");
    let c = (i, t) => t.every(t => i.includes(t)),
        d = $("body").attr("user-type");
    var n;
    $(window).width();

    function s(i) {
        var a = $(i).closest("[data-product-variant]");
        let n = [];
        if ($(a).find("select[option-type]").each(function(t) {
                $(this).hasClass("active") && n.push($(this).find(":selected").attr("value"))
            }),
            $(a).hasClass("quick-view") && p(i, a, n),
            "undefined" != typeof json_product) {
            var s = json_product;
            var o = a;
            var r = n;
            let t, e;
            t = $(i).closest("[data-product-tile-id]").attr("data-product-tile-id"),
                t = parseInt(t),
                s.variants.forEach(t => {
                    if (c(r, t.options)) return e = void 0,
                        e = {
                            id: t.id,
                            available: t.available,
                            selection: s.options,
                            options: t.options,
                            image: t.featured_image,
                            price: t.price,
                            sku: t.sku,
                            user: d
                        }, t = o, null != (i = e).image && (-1 !== jQuery.inArray("Condition", i.selection) && ("loose_leaf" == i.options[0] ? $(t).find(".condition-image").css("background-image", `url(${loose_leaf})`) : "pyramid_bags" == i.options[0] && $(t).find(".condition-image").css("background-image", `url(${pyramid_bags})`)), !/wholesale|search/.test(location.pathname) && l(t, i)), !/wholesale|search/.test(location.pathname) &&  u(o, e), !1;
                    var i
                })
        }
    }

    function l(t, i) {
        null != i.image && ($(t).find(".packaging-image img:not(.collwithout-hover)").attr("src", i.image.src), $(t).find(".packaging-image img:not(.collwithout-hover)").attr("data-src", i.image.src))
    }

    function o(t, i) {
        notify = $(t).hasClass("quick-view") ? (cta = $(t).find(".quick-view-add-cta"), cta = $(cta).find(".add-to-cart"), $(t).find(".sold-out")) : (cta = $(t).find("#add-to-cart"), $(t).find("#notify-me"));
        t = $(t).find(".quantity-incremental input").attr("max");
        0 < parseInt(t) && i.available ? ($(cta).addClass("variant-state"), $(notify).hasClass("variant-state") && $(notify).removeClass("variant-state")) : ($(notify).addClass("variant-state"), $(cta).hasClass("variant-state") && $(cta).removeClass("variant-state"))
    }

    function r(t, i) {
        var e = $(t).find(".quantity-incremental input").attr("value"),
            a = $(t).find(".quantity-incremental input");
        let n, s;
        $(t).find(".product-variant-qtys").each(function(t) {
            $(this).attr("data-variant-id") == i.id && (n = $(this).attr("data-variant-inventory-qty"), n = parseInt(n), s = $(this).attr("data-increment"), s = parseInt(s))
        }), $(a).attr("max", n), $(a).attr("min", s), $(a).attr("increment", s), $(a).attr("value", s), $(a).val(s), 0 == n ? ($(a).val(0), $(a).attr("value", 0), $(a).attr("increment", 0)) : 0 < n && 0 == e && (s = $(a).attr("min"), $(a).val(s))
    }

    function p(t, a, i) {
        let e, n, s;
        e = $(t).closest("[data-product-tile-id]").attr("data-product-tile-id"), parseInt(e), s = $(a).data("handle"), attr = $(a).data("sample")

       let uCalled = false; 
  
          jQuery.ajax({
            url: `/products/${s}.js`,
            dataType: "json",
            success: function(e) {
                e.variants.forEach(t => {
                    if (c(i, t.options)) {
                        n = void 0;
                        let i = [];
                        e.options.forEach(t => i.push(t.name)), n = {
                            id: t.id,
                            available: t.available,
                            selection: i,
                            options: t.options,
                            image: t.featured_image,
                            price: t.price,
                            sku: t.sku,
                            user: d
                        }, 
                         l(a, n);
                    
                        if (attr === "sample") {
                            if (!uCalled) { // Check if u(a, n) has not been called yet
                                u(a, n);
                                uCalled = true; // Set the flag to true after calling u(a, n)
                            }
                        } else {
                            u(a, n);
                        } 
                          
                    }
                })
            }
        })
    }

    function u(t, i) {
        // alert("i.id - "+ i.id);
        // console.log("i.id - "+ i.id);
        // console.log($(t));
        $(t).find("[data-variant-id]").hide(), r(t, i), o(t, i), $(t).attr("data-product-variant", i.id), 0 < $(t).find(".product-sku").length && $(t).find(".product-sku p.sku").text(i.sku), window.BOLD && BOLD.common && BOLD.common.eventEmitter && "function" == typeof BOLD.common.eventEmitter.emit && BOLD.common.eventEmitter.emit("BOLD_COMMON_variant_changed", {
            variant: i
        }), $(t).find("[data-product-id]").show()

        if((i.options.length == 2) && $(".cart-tab-des-paratable .select-options.Size label.active.checked").length){
            var currentsize = $(".cart-tab-des-paratable .select-options.Size label.active.checked").attr("value") ?? '';
            if(i.options[1] && currentsize && (i.options[1] != currentsize)){
                $(".cart-tab-des-paratable .select-options.Size label.active.checked").removeClass("checked");
                $(".cart-tab-des-paratable .select-options.Size label.active[value='"+i.options[1]+"']").addClass("checked");
            }
        }
    }

    function m() {
        $(".product-options .dropdown .product-select").each(function(t) {
            var i = $(this).find(":selected").text();
            $(this).siblings(".selected").children().html(i), $(this).width($(this).siblings(".selected").width())
        })
    }

    function h(t, i) {
        $(t).siblings("input").attr("value", i)
    }
    "undefined" != typeof json_product && (n = json_product, t.forEach(i => {
        let e = $(i).data("product-variant"),
            a;
        n.variants.forEach(t => {
            if (t.id == e) {
                a = {
                    id: t.id,
                    available: t.available,
                    selection: n.options,
                    options: t.options,
                    image: t.featured_image,
                    user: d
                }, r(i, a);
                {
                    var f = i;
                    var y = a;
                    let v = 0;
                    $(f).find("[option-type]").each(function(t) {

                        let h = $(f).find("[option-type]").find("option").length,
                            p = $(this).attr("option-type"),
                            u = $(this).attr("option-select");
                        $(this).find("option").each(function(i) {
                            v += 1;
                            {
                                var e = $(this).val(),
                                    a = p,
                                    n = h,
                                    s = u,
                                    o = f,
                                    r = y,
                                    c = v;
                                let t;
                                if (t = s ? `<label for="${e}" index="${i}" option-type="${s}">
                                          <input type="radio" name="${a}" id="${e}" value="${e}">
                                          ${e.replace(/_/g," ")}
                                          </label>` : `<label for="${e}" index="${i}">
                                          <input type="radio" name="${a}" id="${e}" value="${e}">
                                          ${e.replace(/_/g," ")}
                                          </label>`, 
                                    $(t).attr("value", e).appendTo($(o).find(`[selection-type="${a}"]`)), c == n) {
                                    var d = o;
                                    var l = r;
                                    $(d).find("[option-type]").each(function(t) {
                                        -1 !== jQuery.inArray($(this).attr("option-type"), l.selection) && (-1 !== jQuery.inArray($(this).attr("option-select"), l.options) ? ($(this).addClass("active"), $(this).children().each(function(t) {
                                            var i; - 1 !== jQuery.inArray($(this).attr("value"), l.options) && (i = $(this).attr("value"), $(this).parent().val(i))
                                        })) : "option" == $(this).attr("option-select") ? $(this).addClass("active") : $(this).children().each(function(t) {
                                            var i; - 1 !== jQuery.inArray($(this).attr("value"), l.options) && (i = $(this).attr("value"), $(this).parent().val(i))
                                        }))
                                    }), $(d).find("[selection-type]").each(function(t) {
                                        -1 !== jQuery.inArray($(this).attr("selection-type"), l.selection) && $(this).children().each(function(t) {
                                            void 0 === $(this).attr("option-type") || -1 !== jQuery.inArray($(this).attr("option-type"), l.options) ? ($(this).addClass("active"), -1 !== jQuery.inArray($(this).attr("value"), l.options) && ($(this).addClass("checked"), $(this).children().prop("checked", !0))) : "option" == $(this).attr("option-type") && -1 !== jQuery.inArray($(this).attr("value"), l.options) && ($(this).addClass("checked"), $(this).children().prop("checked", !0))
                                        }), 1 == $(this).children().length && ($(this).parent().addClass("display-only"), $(this).siblings().children(".product-select").attr("disabled", !0))
                                    }), m()
                                }
                                return
                            }
                        })
                    })
                }
                o(i, a), $(i).find("[data-variant-id]").show()
            }
        })
    })), 
      
      0 < $(a).length && (t.forEach(t => {
        $(t).find(".product-select").each(function() {
            1 == $(this).children().length && ($(this).closest(".selection-container").addClass("display-only"), $(this).attr("disabled", !0))
        })
    }), m()), 
      $(".selection-container button").on("click", function() {
        return $(this).parent().hasClass("collapsed") ? $(this).parent().removeClass("collapsed") : $(this).parent().addClass("collapsed"), !1
      }), 
      $(".selection-container .options-select label").on("click", function() {
        
        if ($(this).parent().parent().hasClass("collapsed")) 
          $(this).parent().parent().removeClass("collapsed");
        else {
            var t = $(this).closest("[data-product-variant]");
            $($(this).parent().children()).each(function() {
                $(this).hasClass("checked") && $(this).removeClass("checked")
            });
            let i = $(this).attr("value");
            $(this).addClass("checked"), $(this).parent().parent().addClass("collapsed");
            var e = $(this).parent().siblings(".dropdown").children(),
                a = $(e).find(":selected"),
                a = (a.length && $(a).attr("selected", !1), $(e).find(`option[value="${i}"]`));
                
            $(a).prop("selected", !0), "Condition" == $(this).parent().attr("selection-type") && ($(t).find("[selection-type]").each(function(t) {
                "Size" == $(this).attr("selection-type") && ($(this).children().each(function(t) {
                    $(this).attr("option-type") == i ? ($(this).addClass("active"), 0 == $(this).attr("index") && ($(this).addClass("checked"), $(this).children().prop("checked", !0))) : ($(this).removeClass("active"), $(this).children().prop("checked", !1))
                }), $(this).parent().hasClass("collapsed") && $(this).parent().removeClass("collapsed"))
            }), $(t).find("[option-select]").each(function(t) {
                $(this).attr("option-select") == i ? ($(this).hasClass("active") || $(this).addClass("active"), $(this).find("option:first").attr("selected", !0)) : ($(this).removeClass("active"), $(this).find(":selected").attr("selected", !1))
            })), s(this)

            var activeImages = document.querySelectorAll('.select-options.Size .options-select label.active.checked');
            if (activeImages.length > 1) {
              activeImages[0].classList.remove('checked');
            }
        }
        return !1
    }), 
      $(document).on("change", ".product-select", function() {
        {
            var a = this;
            let i = $(a).find(":selected").attr("value"),
                e = $(a).closest("[data-product-variant]");
          
            "Condition" == $(a).attr("option-type") ? $(e).find("[option-select]").each(function(t) {

                $(this).attr("option-select") == i ? ($(this).addClass("active"), $(this).find("option:first").attr("selected", !0), $(e).find('[selection-type="Condition"]').children().each(function(t) {
                    $(this).attr("value") == i ? ($(this).hasClass("active") || $(this).addClass("active"), $(this).addClass("checked"), $(this).children().prop("checked", !0)) : ($(this).removeClass("active"), $(this).removeClass("checked"), $(this).children().prop("checked", !1))
                })) : ($(this).removeClass("active"), $(this).find(":selected").attr("selected", !1))
            }) : $(a).is("select") && $(e).find("[selection-type]").each(function(t) {
                $(this).attr("selection-type") == $(a).attr("option-type") && $(this).children().each(function(t) {
                    $(this).attr("value") == i ? $(this).hasClass("active") || ($(this).addClass("active"), $(this).addClass("checked"), $(this).children().prop("checked", !0)) : ($(this).removeClass("active"), $(this).removeClass("checked"), $(this).children().prop("checked", !1))
                })
            }), s(a)
        }
        var t;
        m(), t = document.querySelectorAll(".product-image-slider")[0], $(t).hasClass("slick-initialized") && $(t).slick("slickGoTo", $(t).find(".slick-track .variant-image").index())
    }), 
      $(".quantity .qtyplus").on("click", function() {
        var t = $(this).closest("[data-product-variant]");
        let i = $(t).attr("data-product-variant");
        var e = $(this).siblings(".product_quantity"),
            a = $(e).val();
        let n, s, o, r;
        if ($(t).find(".product-variant-qtys").each(function(t) {
                $(this).attr("data-variant-id") == i && (n = $(this).attr("data-variant-inventory-qty"), n = parseInt(n))
            }), o = $(t).find(".quantity-incremental input").attr("increment"), o = parseInt(o), r = $(t).find(".quantity-incremental input").attr("min"), parseInt(r), 0 < n && a < n && !isNaN(a)) return s = 1 == a && 1 < o ? +$(e).val() + (o - 1) : +$(e).val() + o, $(e).val(s), h(this, s), !1
    }), 
      $(".quantity .qtyminus").on("click", function() {
        var t = $(this).closest("[data-product-variant]"),
            i = $(this).siblings(".product_quantity"),
            e = $(i).val(),
            a = $(t).find(".quantity-incremental input").attr("increment");
        if (a = parseInt(a), t = $(t).find(".quantity-incremental input").attr("min"), parseInt(t), 0 < e) {
            if (!isNaN(e) && a <= e) return t = +$(i).val() - a, $(i).val(t), h(this, t), !1;
            $(i).val(0), h(this, 0)
        }
    });
    const i = document.getElementById("add-to-cart");
    window.addEventListener("scroll", function() {
        var t = document.getElementById("product-info");
        t && (window.scrollY > t.offsetHeight + t.offsetTop ? $(i).hasClass("active") && $(i).removeClass("active") : $(i).hasClass("active") || $(i).addClass("active"))
    });
    let v = document.getElementsByClassName("how-to-make-container"),
        f = document.querySelectorAll(".darken-bg"),
        e = ($(".read-howto").on("click", function() {
            $(".how-to-video-slider").slick("slickGoTo", 1)
        }), $(".how-to-video-cta").on("click", function() {
            $(v).addClass("expanded"), $(f).addClass("expanded"), $("#video_tea")[0].src += "&amp;autoplay=1";
        }), $(".close-video").on("click", function() {
            $(v).removeClass("expanded"), $(f).removeClass("expanded")
        }), $(".how-to-make-container .close-video").on("click", function() {
            $(v).removeClass("expanded"), $(f).removeClass("expanded")
        }), $(".product-tile").one("click", function(t) {
            /wholesale|search/.test(window.location.pathname) && (!$(this).hasClass("cart") && $(window).width() <= 768) && (t.preventDefault(), !1);
        }), window.location.pathname);
    if (e = e.split("+"), 1 < e.length)
        for (var y in e)
            if (e[y].includes("condition")) {
                let i = e[y].replace("condition-", "");
                if (i = i.replace("-", "_"), "pyramid_bags" == i) {
                    i;
                    let t = document.querySelectorAll("[data-product-variant]");
                    t.forEach(a => {
                        var t = $(a).data("handle");
                        jQuery.ajax({
                            url: `/products/${t}.js`,
                            dataType: "json",
                            success: function(t) {
                                t.variants.forEach(t => {
                                    if (-1 != $.inArray("pyramid_bags", t.options) && -1 != $.inArray("50_bags", t.options)) return i = a, e = t.options, $(i).find('[option-type="Condition"]').children().each(function(t) {
                                        $(this).attr("value") == e[0] && $(this).prop("selected", !0)
                                    }), $(i).find('[option-type="Size"]').each(function(t) {
                                        $(this).attr("option-select") == e[0] ? ($(this).hasClass("active") || $(this).addClass("active"), $(this).find(`option[value="${e[1]}"]`).prop("selected", !0)) : $(this).removeClass("active")
                                    }), p(i, i, e), m(), !1;
                                    var i, e
                                })
                            }
                        })
                    })
                }
                return !1
            } $(window).resize(function() {
        m()
    })
});